import url from './url'
const AppConsts = {
  userManagement: {
    defaultAdminUserName: 'admin'
  },
  localization: {
    defaultLocalizationSourceName: 'Ednet'
  },
  appBaseUrl: 'http://localhost:8080',
  remoteServiceBaseUrl: url,
  appName: 'EDE.CMS',
  appVersion: 'V5.2.1',
  clientId: 'EdnetPanel'
}
export default AppConsts



// WEBPACK FOOTER //
// ./src/utiltools/appconst.js